<template>
  <div class="register-wrapper">

    <app-header></app-header> <hr>

    <div class="container mt-3">

      <div class="row mb-5">
        
         <div class="col-xl-2 col-lg-2 col-md-1 col-sm-12"></div>
         <div class="col-xl-8 col-lg-8 col-md-10 col-sm-12">
           
           <div class="card rounded">
             
             <div class="card-header">
                <h3 class="text-center">Registration <span class="text-primary">Form</span></h3>
                <p class="text-center">
                  Please fill out the form below to gain access to the Members Area.
                  <br> Fields marked <span class="text-danger">*</span> are required.
                </p>
             </div>

             <form @submit.prevent="Registration()">
                  
                   <div class="card-body">

                      <loading :active.sync="isLoading" 
                        :can-cancel="true" 
                        :on-cancel="onCancel"
                        :is-full-page="true"></loading>
                       
                       <div class="form-group">
                           <label for="fname">First Name <span class="text-danger">*</span></label>
                           <input type="text" class="form-control" id="fname" v-model="first_name" required 
                                    placeholder="Enter your name">
                       </div>

                        <div class="form-group">
                           <label for="lname">Last Name <span class="text-danger">*</span></label>
                           <input type="text" class="form-control" id="lname" v-model="last_name" required 
                                     placeholder="Enter your surname">
                       </div>

                       <div class="form-group">
                           <label for="email">Email Address <span class="text-danger">*</span></label>
                           <input type="email" class="form-control" id="email" v-model="email" required 
                                    placeholder="Enter your email">
                       </div>

                       <div class="form-group">
                           <label for="contact">Phone Number <span class="text-danger">*</span></label>
                           <input type="text" class="form-control" id="contact" v-model="phone" required 
                                    placeholder="Enter your phone number">
                       </div>

                       <div class="form-group">
                          <label>Select Gate Type</label> <br>
                          <select class="form-select" v-model="gateID" @change="getAllStreet()" required>
                            <option value="">Select Gate Type</option>
                            <option v-for="gate in allGateTypes" :value="gate.id" :key="gate.id">
                              {{ gate.name }}
                            </option>
                          </select>
                       </div>

                       <div class="form-group" v-if="allStreets.length > 0">
                          <label>Select Street Name <span class="text-danger">*</span></label> <br>
                          <select class="form-select" v-model="street_name" @change="setUserName()" required>
                            <option value="">Select Street Name</option>
                            <option v-for="street in allStreets" :value="street.name" :key="street.id">
                              {{ street.name }}
                            </option>
                          </select>
                       </div>

                        <div class="form-group" v-else>
                           <label for="stname">Add Street Name <span class="text-danger">*</span></label>
                           <input type="text" class="form-control" id="stname" v-model="street_name" required 
                                    placeholder="Enter your street name">
                        </div>

                        <!-- <div class="form-group">
                           <label for="hse">Add House Number <span class="text-danger">*</span></label>
                           <input type="text" class="form-control" id="hse" v-model="house_number" 
                                    placeholder="Enter your house number">
                        </div> -->

                        <div class="form-group">
                           <label for="uname">Username <span class="text-danger">*</span></label>
                           <input type="text" class="form-control" id="uname" v-model="name" disabled 
                                    placeholder="Enter your username">
                        </div>

                         <div class="form-group">
                            <label for="pass">Password <span class="text-danger">*</span></label>
                            <input class="form-control" type="password" v-model="password"
                                    placeholder="Enter Password" required id="pass" minlength="6">
                         </div>

                         <div class="form-group">
                            <label for="conpass">Confirm Password <span class="text-danger">*</span></label>
                            <input class="form-control" type="password" v-model="passwordRep"
                                    placeholder="Enter Confirm Password" required id="conpass" minlength="6">
                         </div>

                        <div class="form-group">
                            <input type="checkbox" @click="visiblePass()"> Check to show password
                        </div>

                        <div class="form-group">
                           <vue-recaptcha class="g-recaptcha" sitekey="6LesHssUAAAAADUe_SCjcGxhc3QtkYXr4rvIzf93"  style="transform:scale(0.77);-webkit-transform:scale(0.83);transform-origin:0 0;-webkit-transform-origin:0 0;" :loadRecaptchaScript="true"></vue-recaptcha>
                        </div>


                   </div>
                   <div class="card-footer">
                       <button type="submit" class="btn btn-outline-primary btn-block">Register Account</button>
                   </div>

             </form>

           </div>

         </div>
         <div class="col-xl-2 col-lg-2 col-md-1 col-sm-12"></div>

      </div>
        
    </div>
  
    <app-footer></app-footer>
  </div>
</template>

<script>
import Header from '@/components/layout/NewHeader'
import Footer from '@/components/layout/NewFooter'
import UserServices from "../../services/UserServices";
import VueRecaptcha from 'vue-recaptcha';
import Loading from 'vue-loading-overlay';
export default {
  components: {
    'app-header': Header,
    'app-footer': Footer,
    VueRecaptcha,
    Loading,
  },
  data() {
    return {
      window: {
        width: 0
      },
      grey: false,
      name: '', 
      first_name: '',
      last_name: '',
      street_name: '0',
      house_number: '',
      password: '',
      wrong: false,
      passwordRep: '',
      email: '',
      phone: '',
      gateID:'',
      popup:false,
      notValid: false,
      wrongPass: false,
      alreadyTaken: false,
      allGateTypes:[],
      allStreets:[],
      isLoading:false,
    }
  },

  created() {
    if(localStorage.token){
      this.$router.push('/');
    }
    this.getAllGateType();
    this.clear();
  },

  mounted() {
    
  },

  methods: {

    visiblePass(){
        let x = document.getElementById("pass");
        let y = document.getElementById("conpass");
        if (x.type === "password" || y.type === "password") {
            x.type = "text";
            y.type = "text";
        } else {
            x.type = "password";
            y.type = "password";
        }
    },

    handleResize() {
      this.window.width = window.innerWidth;
      if (this.window.width <= 480) {
        this.grey = true
      } else {
        this.grey = false
      }
    },

    setUserName(){
        this.name = this.street_name.replace(/-|\s+/g,'');
        console.log(this.name);
    },

    async register() {
        this.house_number = "123";
        const responce = await UserServices.userRegister(this.name, this.first_name, this.last_name, this.street_name, this.house_number, this.password, this.email, this.phone);
        console.log('Response', responce);
        return responce;
    },

    async gatetype(){
      try {
         const response = await UserServices.allGateType();
         return response;
      } catch (error) {
        console.log('error', error);
        return error;
      }
    },

    async getstreet(id){
      try {
         const response = await UserServices.getGateStreet(id);
         return response;
      } catch (error) {
        console.log('error', error);
        return error;
      }
    },

    getAllGateType(){
       this.gatetype().then((res) => {
          this.allGateTypes = res.data.data;
       });
    },

    getAllStreet(){
      this.allStreets = [];
        this.getstreet(this.gateID).then((res) => {
          this.allStreets = res.data.data;
       });
    },

    Registration() {

      if (this.password !== this.passwordRep) {
          this.$swal.fire("Failed :", "Please Confirm Password", "warning");
      } else if(this.password.length < 6){
          this.$swal.fire("Sorry :", "Password length should be more than 6", "warning");
      } else {
             
          this.isLoading = true;
          
          this.register().then((response) => {

            console.log("Is here" + response.status);

            if(response.status !== 200)  {
               this.isLoading = false;
               this.$swal.fire("Failed :", "Email has been registered","warning");
            } else {
               this.isLoading = false;
               this.$swal.fire("Success :", "Your account is waiting for approval", "success");
            }

          }).catch((error) => {
              console.log(error);
              this.isLoading = false;
              this.$swal.fire("Sorry :", "An Unknown error occurred", "warning");
          });
      }

    },

    close() {
      setTimeout(() => {
        this.$router.push('/');
      }, 1000);
    },

    clear(){
      this.name = '';
      this.first_name = '';
      this.last_name = '';
      this.password = '';
      this.email = '';
      this.street_name = '';
      this.house_number = '';
      this.passwordRep = '';
      this.phone = '';
    },

  }
}
</script>

<style lang="scss" scoped>

 .form-select {
   padding-left: 20px;
    font-size: 1rem;
    height: 50px;
    width: 100%;
    line-height: 1.5;
    color: #495057;
    background-color: #fff;
    border: 2px solid #ced4da;
    border-radius: 0.25rem;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  }

.register {
  margin: 0 auto;
  position: relative;
  &-wrapper {
    width: 100%;
    background-color: #ffffff;
  }
  &_title {
    padding-left: 10%;
    padding-top:102px;
    @media screen and (min-width: 1441px) {
      padding-left: 20%;
    }
    @media screen and (max-width: 768px) {
      padding-left: 14px;
    }
    &-subtitle {
    color: #adadad;
    font-family: "Open Sans";
    font-size: 12px;
    font-weight: 600;
    line-height: 36px;
    text-transform: uppercase;
    font-family: "Open Sans";
    letter-spacing: 0.3px;
  }
  &-h1 {
    color: #38383a;
    font-family: "Optimal C";
    font-size: 22px;
    font-weight: 400;
    text-transform: uppercase;
    letter-spacing: 0.07px;
    line-height:1.5;
    span {
      color: #fe0012;
      font-family: "Optimal C";
      font-size: 22px;
      font-weight: bold;
      letter-spacing: 0.4px;
    }
  }
  &_border {
    width: 63px;
    height: 3px;
    background-color: #2a9854;
    margin-bottom: 79px;
  }
}
  &_form {
    &-wrong {
      color:red;
      font-family: "Optimal C";
      font-size: 24px;
      font-weight: 400;
      text-align: center;
      margin-bottom:0;
    }
    &-button {
      width: 25%;
      min-width:213px;
      margin-top:65px;
      @media screen and (max-width: 560px) {
        margin-top:45px;
      }
      @media screen and (max-width: 480px) {
        margin:0 auto;
      }
    }
    &_row {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      padding-left: 10%;
      padding-right: 10%;
      padding-top:25px;
      @media screen and (min-width: 1441px) {
        padding-right: 25%;
        padding-left: 20%;
      }
      @media screen and (max-width: 768px) {
        padding-left: 14px;
        padding-right: 14px;
      }
      @media screen and (max-width: 480px) {
        flex-direction: column;
        padding:0;
      }
      &-grey {
        background-color: #f2f2f2;
        @media screen and (max-width: 480px) {
          padding: 20px 24px 20px 14px;
          width: 90%;
        }
      }
      &-wrong {
        border-bottom: 1px solid red;
      }
      &-input {
        width:40%;
        @media screen and (max-width: 480px) {
          padding: 20px 24px 20px 14px;
          width: 90%;
        }
      }
    }
    &_captcha {
      @media screen and (max-width: 768px) {
        width:auto;
        justify-content: flex-start;
      }
      @media screen and (max-width: 480px) {
        flex-direction: column-reverse;
        margin-left: 15px;
      }
    }
    &_col {
      display: flex;
      flex-direction: column;
      margin-bottom: 90px;
      width:50%;
      @media screen and (max-width: 768px) {
        width:50%;
        margin-right: 10%;
      }
      @media screen and (max-width: 560px) {
        margin-right: 20px;
      }
      &-p {
        color: #7a7a7d;
        font-family: "Open Sans";
        font-size: 16px;
        font-weight: 400;
        line-height: 24px;
        letter-spacing: 0.4px;
        width:40%;
        @media screen and (max-width: 768px) {
        width:100%;
      }
      }
      &_btn {
        width:40%;
        display:flex;
        @media screen and (max-width: 480px) {
          margin-bottom:25px;
        }
      }
    }
  }
}
.g-recaptcha iframe {
  @media screen and (max-width: 768px) {
    max-width: 100%;
    transform:scale(0.77);
    -webkit-transform:scale(0.77);
    transform-origin: center center;
    -webkit-transform-origin: center center;
  }
  }
  #rc-imageselect {
    transform:scale(0.77);
    -webkit-transform:scale(0.77);
    transform-origin:0 0;
    -webkit-transform-origin:0 0;
  }
.popup {
  &-wrapper {
    position: fixed;
    top:0;
    left:0;
    width: 100%;
    height:100vh;
  }
  text-align: center;
  position: absolute;
  top:40%;
  left:35%;
  padding:20px;
  color: white;
  font-family: "Open Sans";
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.4px;
  border-radius: 8px;
  background-color: #2a9854;
  box-shadow: 6px 10px 32px rgba(0, 0, 0, 0.2);
  &-close {
    position: absolute;
    right:15px;
    top:12px;
    cursor: pointer;
  }

 

}
</style>
